module.exports = __webpack_public_path__ + "media/brands/kip-5ea6b79a.png";